import { Skeleton } from '@zoomit/primitives';
import { List, ListItem, RedDot } from '@zoomit/zoomit-ds';

type Props = {
  countOfSkeletons: number;
};

const TextItemSkeleton = (props: Props) => {
  const { countOfSkeletons } = props;
  return (
    <List>
      {Array.from({ length: countOfSkeletons }).map((_, index) => (
        <ListItem indicator={<RedDot />} key={index} spacing={{ mb: 'x3' }}>
          <Skeleton variant="text" width={26} className="mt-1" />
        </ListItem>
      ))}
    </List>
  );
};

export default TextItemSkeleton;
